import { ReactNode } from 'react';
import cx from 'classnames';

import { useTailwind } from '@/hooks/useTailwind';

import { LabelTheme } from './API/LabelTheme';

interface LabelProps {
    className?: string;
    theme?: LabelTheme;
    children: ReactNode;
}

const Label = ({ className = '', theme = null, children }: LabelProps) => {
    const tw = useTailwind(className);

    return (
        <label className={cx('w-full inline-flex items-start sm:items-center gap-x-2 font-medium', {
            'leading-6 text-lg sm:text-xl': ! tw.hasTextSize(),
            'text-white': theme === 'light',
            'text-black': theme === 'dark',
            'text-primary-500': Boolean(theme) === false,
            [className]: Boolean(className)
        })}>
            {children}
        </label>
    );
};

export { Label };